// eslint-disable-next-line no-unused-vars
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./gnp-multicanal.css";
import MulticanalFlujos from './multicanalFlujos.cmpt';

const mapState = state => {
   return {
      loading: state.global.loading,
      nombre: state.global.nombre,
      multicanalGnp: state.multicanalGnp,
      polizasDanios: state.polizas.danios
   };
};

class MulticanalSeguimiento extends Component {
   state = {
      mostrarSeguimiento: true,
      mostrarHistorial: false,
      secondMenuTitle: "Trámites y seguimiento",
      arrowOrange: [
         require("../img/arrow-down.svg"),
         require("../img/arrow-up.svg")
      ],
      tabActivaStr: "SEGUIMIENTO_SINIESTRO",
      arrowIndexTabs: 0,
      alta: true,
      historial: false,
      mobileTabs: false
   }

   seleccionSiniestros = opcion => {
      var estadoTemporal = {
         mostrarSeguimiento: false,
         mostrarHistorial: false,
         tabActivaStr: opcion
      };
      switch (opcion) {
         case "SEGUIMIENTO_SINIESTRO":
            estadoTemporal.mostrarSeguimiento = true;
            break;
         case "HISTORIAL_SINIESTRO":
            estadoTemporal.mostrarHistorial = true;
            break;
         default:
      }
      this.setState(estadoTemporal);
   }

   showMobileTabs = () => {
      var arrowIndexTabs;
      if (this.state.arrowIndexTabs == 1) {
         arrowIndexTabs = 0;
      } else if (this.state.arrowIndexTabs == 0) {
         arrowIndexTabs = 1;
      }

      this.setState({
         "mobileTabs": !this.state.mobileTabs,
         "arrowIndexTabs": arrowIndexTabs,
      });
   }

   polizas = ()  => {
      const polizas = this.props.polizasDanios.map(poliza => poliza.generales.numPoliza);
      return JSON.stringify(polizas);
   }

   render() {
      return (
         <div>
            <div className="tercer-menu text-center hide-mobile">
               <ul className="clearfix">
                  <li>
                     <button
                        disabled={this.state.mostrarSeguimiento}
                        className={this.state.mostrarSeguimiento ? "active" : ""}
                        onClick={() => this.seleccionSiniestros("SEGUIMIENTO_SINIESTRO")}
                     >
                        Trámites y seguimiento
							</button>
                  </li>
                  <li>
                     <button
                        disabled={this.state.mostrarHistorial}
                        className={this.state.mostrarHistorial ? "active" : ""}
                        onClick={() => this.seleccionSiniestros("HISTORIAL_SINIESTRO")}
                     >
                        Historial
							</button>
                  </li>
               </ul>
            </div>

            <div className="second-menu text-center show-mobile">
               <div className="second-menu-select-mobile">
                  <p onClick={this.showMobileTabs}>{this.state.secondMenuTitle}
                     <img src={this.state.arrowOrange[this.state.arrowIndexTabs]} />
                  </p>
                  {this.state.mobileTabs &&
                     <ul>
                        <li >
                           <button
                              disabled={this.state.mostrarSeguimiento}
                              onClick={() => this.seleccionSiniestros("SEGUIMIENTO_SINIESTRO")}
                           >Trámites y seguimiento</button>
                           <div className={this.state.mostrarSeguimiento ? "active" : ""}></div>
                        </li>
                        <li>
                           <button
                              disabled={this.state.mostrarHistorial}
                              onClick={() => this.seleccionSiniestros("HISTORIAL_SINIESTRO")}
                           >
                              Historial
									</button>
                           <div className={this.state.mostrarHistorial ? "active" : ""}></div>
                        </li>
                     </ul>
                  }
               </div>
            </div>
            <div className="container-tabla-seguimiento">
               <MulticanalFlujos numPoliza={this.polizas()} flujo={this.state.tabActivaStr}/>
            </div>
         </div>
      );
   }
}

MulticanalSeguimiento.propTypes = {
   numPoliza: PropTypes.string,
   flujo: PropTypes.string,
};

export default connect(mapState)(MulticanalSeguimiento);


// WEBPACK FOOTER //
// ./src/gnp-multicanal/multicanalSeguimiento.cmpt.js